import { useEffect } from 'react';
import { useAppSelector } from '@store/index';
import { selectTheme } from '@features/ui/uiSlice';

/**
 * Has to live on <html>, not a shell wrapper: Radix portals mount on <body> and
 * would otherwise resolve the light tokens while the app is dark.
 */
export function useThemeClass(): void {
  const theme = useAppSelector(selectTheme);

  useEffect(() => {
    document.documentElement.classList.toggle('dark', theme === 'dark');
  }, [theme]);
}
